import { compose, lifecycle } from 'recompose';
import { addMetaTagToHead } from '../Helper';

const META_TWITTER_CARD_TAG = 'twitter:card';

const createTwitterCardTag = () => {
  const twitterCardTag = document.querySelector(`meta[name="${META_TWITTER_CARD_TAG}"]`);
  if (!twitterCardTag) {
    addMetaTagToHead({ name: META_TWITTER_CARD_TAG, content: 'summary_large_image' });
  }
}

export const WithTwitterTag = compose(
  lifecycle({
    componentDidMount() {
      if (window.location.href.indexOf('/ephotobook/preview') === -1) {
        createTwitterCardTag();
      }
    }
  })
);



// WEBPACK FOOTER //
// ./src/Common/Helmet/WithTwitterTag.js